import * as Yup from 'yup';

export const formValidationSchema = Yup.object().shape({
  tgl_seleksi_vendor_aset: Yup.string().required('Masukan tanggal'),
  harga_kesepakatan: Yup.string().required('Masukan harga kesepakatan'),
  id_vendor: Yup.string().required('Pilih vendor'),
});
